import { render } from "./AddNewCustomerComponent.vue?vue&type=template&id=457b7bea&scoped=true"
import script from "./AddNewCustomerComponent.vue?vue&type=script&lang=js"
export * from "./AddNewCustomerComponent.vue?vue&type=script&lang=js"

import "./AddNewCustomerComponent.vue?vue&type=style&index=0&id=457b7bea&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457b7bea"]])

export default __exports__